module.exports = __webpack_public_path__ + "static/media/sample_image_one.aa6177ae.png";